export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8775.e96c54a8.jpg";